export default "__VITE_ASSET__B$Y29IY___"